"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PG_ID_IDENTIFIER_REGEX = exports.PG_COLUMN_IDENTIFIER_REGEX = exports.S3_IDENTIFIER_REGEX = exports.COLOR_HEX_CODES = exports.POSTGRES_ID_MARKER = exports.POSTGRES_COLUMN_MARKER = exports.S3_PATH_MARKER = exports.regExpFullDateTimeStr = exports.regExpFullDateStr = exports.loanTapeType = exports.plaidRedirectUri = exports.plaidEnvForNodeEnv = exports.plaidAssetReportTransactionDays = exports.MSR_ALPHA_ORGANIZATION_SLUGS = exports.MAX_TIMESTAMP = exports.maxFutureBusinessDaysReportingDate = exports.DEVELOPMENT_S3_ROOT = exports.CURRENT_CREDIT_AGREEMENT_DOCUMENT_SCHEMA_VERSION = exports.closeOfBusinessHour = exports.cashBalanceFeedContributionAccountTypes = exports.borrowingBaseContributionAccountTypes = exports.bankDataProviderKeys = exports.MAX_BRUTE_FORCE_KNAPSACK_ITEM_COUNT = void 0;
const finley_types_1 = require("@finley-technologies/finley-types");
const bankDataProviderKeys = {
    plaid: 'plaid',
    teller: 'teller',
    manualDashboard: 'manualDashboard',
    manualS3Upload: 'manualS3Upload',
};
exports.bankDataProviderKeys = bankDataProviderKeys;
const regExpFullDateStr = /^\d{4}-\d{2}-\d{2}$/;
exports.regExpFullDateStr = regExpFullDateStr;
const regExpFullDateTimeStr = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
exports.regExpFullDateTimeStr = regExpFullDateTimeStr;
const borrowingBaseContributionAccountTypes = [
    finley_types_1.Bank.BorrowerAccountType.Collections,
    finley_types_1.Bank.BorrowerAccountType.PreFundingAccount,
    finley_types_1.Bank.BorrowerAccountType.PermittedInvestmentsAccount,
    finley_types_1.Bank.BorrowerAccountType.AccountIncludedInBorrowingBase,
];
exports.borrowingBaseContributionAccountTypes = borrowingBaseContributionAccountTypes;
const cashBalanceFeedContributionAccountTypes = [
    ...borrowingBaseContributionAccountTypes,
    finley_types_1.Bank.BorrowerAccountType.OtherReserveAccount,
];
exports.cashBalanceFeedContributionAccountTypes = cashBalanceFeedContributionAccountTypes;
// manual uploader "uploads" files to local file system when running on development environment.
// we use "~/${DEVELOPMENT_S3_ROOT}/${bucket}/${key}" for such uploads.
const DEVELOPMENT_S3_ROOT = 'local_s3';
exports.DEVELOPMENT_S3_ROOT = DEVELOPMENT_S3_ROOT;
const CURRENT_CREDIT_AGREEMENT_DOCUMENT_SCHEMA_VERSION = finley_types_1.CreditAgreement.DomainEntity.CreditAgreementSchemaVersion['1.0'];
exports.CURRENT_CREDIT_AGREEMENT_DOCUMENT_SCHEMA_VERSION = CURRENT_CREDIT_AGREEMENT_DOCUMENT_SCHEMA_VERSION;
/*
const PlaidEnvironments: PlaidEnvironment = {
  prod: 'https://production.plaid.com',  // live data
  sandbox: 'https://sandbox.plaid.com', // fake data
  development: 'https://development.plaid.com', // live data, limited for 100 real accounts, only for initial testing prior to moving to prod
};

Update when ready for prod

*/
const plaidEnvForNodeEnv = {
    development: 'sandbox',
    stage: 'sandbox',
    prod: 'prod',
    'client-uat': 'prod',
    client: 'prod',
};
exports.plaidEnvForNodeEnv = plaidEnvForNodeEnv;
const plaidRedirectUri = {
    development: 'https://app.stage.finleycms.com/settings/integrations',
    stage: 'https://app.stage.finleycms.com/settings/integrations',
    prod: 'https://app.finleycms.com/settings/integrations',
    'client-uat': 'https://app.client.uat.finleycms.com/settings/integrations',
    client: 'https://app.client.finleycms.com/settings/integrations',
};
exports.plaidRedirectUri = plaidRedirectUri;
const plaidAssetReportTransactionDays = 180;
exports.plaidAssetReportTransactionDays = plaidAssetReportTransactionDays;
const closeOfBusinessHour = 17;
exports.closeOfBusinessHour = closeOfBusinessHour;
const MAX_TIMESTAMP = 8640000000000000; // milliseconds
exports.MAX_TIMESTAMP = MAX_TIMESTAMP;
const loanTapeType = {
    masterLoanTape: 'masterLoanTape',
    preassignedLoanTape: 'preassignedLoanTape',
    preassignedMasterLoanTape: 'preassignedMasterLoanTape',
};
exports.loanTapeType = loanTapeType;
// max number of business days in the future that a loan tape is valid for
const maxFutureBusinessDaysReportingDate = 1;
exports.maxFutureBusinessDaysReportingDate = maxFutureBusinessDaysReportingDate;
exports.MAX_BRUTE_FORCE_KNAPSACK_ITEM_COUNT = 25;
/**
 * List of reserved markers used to parse identifier of Borrowing Base Pipeline Artifact Instance Identifier
 */
const S3_PATH_MARKER = `#s3Path:`;
exports.S3_PATH_MARKER = S3_PATH_MARKER;
const POSTGRES_COLUMN_MARKER = `#column:`;
exports.POSTGRES_COLUMN_MARKER = POSTGRES_COLUMN_MARKER;
const POSTGRES_ID_MARKER = `#id:`;
exports.POSTGRES_ID_MARKER = POSTGRES_ID_MARKER;
const S3_IDENTIFIER_REGEX = `^${S3_PATH_MARKER}(.*)$`;
exports.S3_IDENTIFIER_REGEX = S3_IDENTIFIER_REGEX;
const PG_COLUMN_IDENTIFIER_REGEX = `^${POSTGRES_COLUMN_MARKER}(.*)${POSTGRES_ID_MARKER}.*$`;
exports.PG_COLUMN_IDENTIFIER_REGEX = PG_COLUMN_IDENTIFIER_REGEX;
const PG_ID_IDENTIFIER_REGEX = `^${POSTGRES_COLUMN_MARKER}.*${POSTGRES_ID_MARKER}(.*)$`;
exports.PG_ID_IDENTIFIER_REGEX = PG_ID_IDENTIFIER_REGEX;
/**
 * Common Styling Attributes
 */
const COLOR_HEX_CODES = {
    RED: '#FF0000',
    YELLOW: '#FFFF00',
    BLUE: '#0000FF',
};
exports.COLOR_HEX_CODES = COLOR_HEX_CODES;
/**
 * @jendevelops MSR-TODO remove once adjusting current   is GA
 *
 * List of borrowers that are allowed to adjust current liabilities (alpha users for deliverables MSR)
 *
 * TODO: can we remove this without causing issues? maybe not, who knows at this point
 */
const MSR_ALPHA_ORGANIZATION_SLUGS = [
    // round 1
    'acmeCorp', // DEMO ORG
    'mercury',
    'tripActions',
    'vaya',
    // round 2
    'imprint',
    'foraFinancialWarehouseLlc',
    'nectar',
    'parker',
    'ramp',
    // round 3
    'coitTowerTechnologies', // DEMO ORG
    'achieve',
];
exports.MSR_ALPHA_ORGANIZATION_SLUGS = MSR_ALPHA_ORGANIZATION_SLUGS;
//# sourceMappingURL=consts.js.map